import SspChildrens from "./childrens/ssp-childrens";

import { useUserStore } from "@/store/modules/user"; // Assuming the user store is in this location
import getCurrentUser from "@/router/middleware/getCurrentUser";

const OidcCallback = () =>
  import(/* webpackChunkName: "OidcCallback" */ "@/components/OidcCallback.vue");
const Ssp = () => import(/* webpackChunkName: "Ssp" */ "@/components/Ssp.vue");

export const desktopRouter = [
  {
    path: "/",
    children: SspChildrens,
    component: Ssp,
    beforeEnter: (to, from, next) => {
      const userStore = useUserStore();
      return getCurrentUser(userStore)(to, from, next);
    },
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];
